"use strict";
function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map


//////////////////
// WEBPACK FOOTER
// P:/Projetos/PoloVeiculos/Fonte/PoloApp/SiteV3/polo-app/node_modules/rxjs/util/isFunction.js
// module id = ../../../../rxjs/util/isFunction.js
// module chunks = vendor